// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPeopleOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 6.5c-.832 0-1.5.668-1.5 1.5S7.168 9.5 8 9.5 9.5 8.832 9.5 8 8.832 6.5 8 6.5zM11.5 8c0 1.937-1.563 3.5-3.5 3.5A3.495 3.495 0 0 1 4.5 8c0-1.937 1.563-3.5 3.5-3.5s3.5 1.563 3.5 3.5zm1.396 9c-.15-.368-.48-.743-1.094-1.103C10.862 15.347 9.481 15 8 15c-1.48 0-2.863.347-3.802.897-.615.36-.944.735-1.094 1.103zM8 13c3.28 0 6.56 1.414 6.96 4a3.5 3.5 0 0 1 .04.537V19H1v-1.463c0-.184.014-.363.04-.537.4-2.586 3.68-4 6.96-4zm8-3.5c.832 0 1.5-.668 1.5-1.5s-.668-1.5-1.5-1.5-1.5.668-1.5 1.5.668 1.5 1.5 1.5zM12.5 8c0-1.937 1.563-3.5 3.5-3.5s3.5 1.563 3.5 3.5-1.563 3.5-3.5 3.5A3.495 3.495 0 0 1 12.5 8zM23 19h-6v-1.463c0-.18-.009-.36-.026-.537h3.922c-.15-.368-.48-.743-1.094-1.103-.859-.503-2.087-.836-3.423-.89-.408-.772-.985-1.415-1.642-1.937.417-.046.84-.07 1.263-.07 3.28 0 6.56 1.414 6.96 4a3.5 3.5 0 0 1 .04.537z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPeopleOutlined;
